import Api from "./Api";

export const getOrganizationDetails = async () => Api().get(`organization/`);

export const saveOrganizationDetails = async (payload) =>
  Api().post(`organization/save`, payload);
